function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ApolloProvider } from "@apollo/client";
import { maybeAddRequestMarkers } from "@stripe-internal/request-markers";
import { useMemo } from "react";
import { createApolloClient } from "../../../internal/apollo/client";
import DataConfigContext from "../../../internal/config/DataConfigContext";
import KillSwitchProvider from "../../../internal/killswitch/KillSwitchProvider";
import DataRevampLayer from "../../../internal/revamp/DataRevampLayer";
import Headers from "../../../internal/shared/headers/headers";
import useOnChangedUser from "../../../internal/user/useOnChangedUser";
import addLanguageHeaders from "../../headers/addLanguageHeaders";
function OnChangeLoggedUser({ onChangeLoggedUser }) {
    useOnChangedUser(onChangeLoggedUser);
    return null;
}
export default function DataProvider({ children, config }) {
    const client = useMemo(()=>config.graphql ? createApolloClient(config.graphql) : null, [
        config.graphql
    ]);
    // The `<DataProvider>` ensures that when calling the provided fetch, headers
    // are always passed as a record following the `FetchOptions` type. The
    // normalization is made by the `@sail/data` `Headers` class.
    const fetch = useMemo(()=>{
        const fetch = config.fetch;
        if (!fetch) {
            return fetch;
        }
        return (url, options)=>{
            var _options_headers;
            const headers = new Headers((_options_headers = options === null || options === void 0 ? void 0 : options.headers) !== null && _options_headers !== void 0 ? _options_headers : {});
            if (config.locale) {
                addLanguageHeaders(headers, config.locale);
            }
            const markerRes = maybeAddRequestMarkers(url, headers.getFetchHeaders());
            return fetch(markerRes.url, _object_spread_props(_object_spread({}, options), {
                headers: markerRes.headers
            }));
        };
    }, [
        config.fetch,
        config.locale
    ]);
    const configWithFetch = useMemo(()=>{
        return _object_spread_props(_object_spread({}, config), {
            fetch
        });
    }, [
        config,
        fetch
    ]);
    if (!client) {
        return /*#__PURE__*/ _jsx(DataConfigContext.Provider, {
            value: configWithFetch,
            children: /*#__PURE__*/ _jsx(KillSwitchProvider, {
                children: children
            })
        });
    }
    const handleChangedUser = config.onChangeLoggedUser;
    return /*#__PURE__*/ _jsx(DataConfigContext.Provider, {
        value: configWithFetch,
        children: /*#__PURE__*/ _jsxs(KillSwitchProvider, {
            children: [
                /*#__PURE__*/ _jsx(ApolloProvider, {
                    client: client,
                    children: /*#__PURE__*/ _jsx(DataRevampLayer, {
                        config: config.unstable_sail_data_revamp,
                        fetchFromOldProvider: fetch,
                        children: children
                    })
                }),
                handleChangedUser ? /*#__PURE__*/ _jsx(OnChangeLoggedUser, {
                    onChangeLoggedUser: handleChangedUser
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}

//# sourceMappingURL=DataProvider.js.map